let SearchDataDict = [
    {
        "project": "qqshangtong",
        "zh":[
            { label: "化橘红" },
            { label: "广藿香" },
            { label: "广陈皮" },
            { label: "广佛手" },
        ],
        "en":[
            { label: "Citrus grandis 'Tomentosa'" },  // 化橘红
            { label: "Pogostemon cablin" },         // 广藿香
            { label: "Guangdong Tangerine Peel" },  // 广陈皮
            { label: "Guangdong Finger Citron" }    // 广佛手
        ]
    }
]
 module.exports = SearchDataDict